import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";

interface GrowthIndicatorResponse {
  growth_indicators: [number, number];
  is_growth_indicator_updated: boolean;
}

export const useGrowthIndicator = () => {
  return useQuery<GrowthIndicatorResponse>({
    queryKey: ["growth-indicator"],
    queryFn: async () => {
      const response = await httpService.get<GrowthIndicatorResponse>(
        API_CONFIG.path.getGrowthIndicator
      );
      return response;
    },
    retry: false, // Don't retry if user hasn't set the indicator yet
  });
};
